import PaymentMethodACH from '@assets/icons/payment-method-ach.svg';
import PaymentMethodAmex from '@assets/icons/payment-method-amex.svg';
import PaymentMethodDefault from '@assets/icons/payment-method-default.svg';
import PaymentMethodDiscover from '@assets/icons/payment-method-discover.svg';
import PaymentMethodMC from '@assets/icons/payment-method-mc.svg';
import PaymentMethodPad from '@assets/icons/payment-method-PAD.svg';
import PaymentMethodPayTo from '@assets/icons/payment-method-payto.svg';
import PaymentMethodTab from '@assets/icons/payment-method-tab.svg';
import PaymentMethodVisa from '@assets/icons/payment-method-visa.svg';
import React from 'react';
import { ImageStyle, StyleProp } from 'react-native';
import { PaymentMethod } from '@/enums';

export interface Props {
  style?: StyleProp<ImageStyle>;
  type: PaymentMethod;
}

export const PaymentMethodIcon: React.FC<Props> = ({ type, style }) => {
  switch (type) {
    case PaymentMethod.ACH:
      return (
        <PaymentMethodACH style={style} testID="payment-method-icon-ach" />
      );
    case PaymentMethod.AMEX:
      return (
        <PaymentMethodAmex style={style} testID="payment-method-icon-amex" />
      );
    case PaymentMethod.DISCOVER:
      return (
        <PaymentMethodDiscover
          style={style}
          testID="payment-method-icon-discover"
        />
      );
    case PaymentMethod.PAD:
      return (
        <PaymentMethodPad style={style} testID="payment-method-icon-pad" />
      );
    case PaymentMethod.PAYTO:
      return (
        <PaymentMethodPayTo style={style} testID="payment-method-icon-payto" />
      );
    case PaymentMethod.MC:
      return <PaymentMethodMC style={style} testID="payment-method-icon-mc" />;
    case PaymentMethod.TAB:
      return (
        <PaymentMethodTab style={style} testID="payment-method-icon-tab" />
      );
    case PaymentMethod.VISA:
      return (
        <PaymentMethodVisa style={style} testID="payment-method-icon-visa" />
      );
  }

  return (
    <PaymentMethodDefault style={style} testID="payment-method-icon-default" />
  );
};
